<template>
  <div v-if="subjects">
    <div class="page-title"> 교과 편성 총괄표 </div>
    <div class="mt-3">
      <folder-label v-if="subjects.CULTURE && subjects.CULTURE.length" label="NCS 교양">
        <div v-for="s in subjects.CULTURE" :key="s._id">
          {{s.name}}
        </div>
      </folder-label>
      <folder-label v-if="subjects.NCS && subjects.NCS.length" label="NCS 교과" :open="true">
        <folder-label v-for="(s, ix) in subjects.NCS" :key="s._id"
          label-icon="chalkboard-teacher" class="ml-4" :label="s.name" :open="ix === 0 ? true : false">
          <div class="bolder ml-4">
            <div class="left-cell underline" style="width:95%" ><mdb-badge>능력단위</mdb-badge></div>
            <div class="left-cell underline text-right" style="width:80px">{{totalHours(s)}}</div>
          </div>
          <div v-for="l in s.lectures" :key="l._id" class="ml-4 my-2">
            <div class="left-cell underline" style="width:100%" ><mdb-icon  icon="chalkboard" /> {{l.name}}</div>
            <div class="left-cell underline w-10">{{l.hours}}</div>
          </div>
        </folder-label>
      </folder-label>
      <folder-label class="mt-4" v-if="subjects.NONNCS && subjects.NONNCS.length" label="비 NCS 교과" :open="true" >
        <folder-label v-for="(s, ix) in subjects.NONNCS" :key="s._id"
            label-icon="chalkboard-teacher" class="ml-4" :label="s.name" :open="ix === 0 ? true : false">
          <div class="bolder ml-4">
            <div class="left-cell underline" style="width:95%" ><mdb-badge>중단원</mdb-badge></div>
            <div class="left-cell underline text-right" style="width:80px">{{totalHours(s)}}</div>
          </div>
          <div v-for="l in s.lectures" :key="l._id" class="ml-4 my-2">
            <div class="left-cell underline" style="width:100%" ><mdb-icon  icon="chalkboard" /> {{l.name}}</div>
            <div class="left-cell underline w-10">{{l.hours}}</div>
          </div>
        </folder-label>
      </folder-label>
      <!-- <culture-subjects-edit v-if="active === 0" :subjects="subjects.CULTURE"/>
      <ncs-subjects-edit v-if="active === 1" :subjects="subjects.NCS" />
      <non-ncs-subjects-edit v-if="active === 2" :subjects="subjects.NONNCS"/> -->
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import FolderLabel from '../../../components/common/FolderLabel.vue'
export default {
  name: 'TrainingStructure',
  components: { FolderLabel },
  data () {
    return {
      TAG: 'TrainingStructure >>'
    }
  },
  computed: {
    ...mapState('training', ['subjects'])
  },
  methods: {
    totalHours (s) {
      let total = 0
      total = s.lectures.reduce((acc, c) => {
        acc += c.hours
        return acc
      }, 0)
      return total
    }
  }
}
</script>
